import React, { useState, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputBase,
  Button,
  Box,
  Typography,
  Skeleton,
} from "@mui/material";
import { Search as SearchIcon, Clear as ClearIcon } from "@mui/icons-material";
import { View, Text } from "react-native";
import { StyleSheet } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { useSelector } from "react-redux";
import { backgroundColor } from "../constants/Constants.js";
import { translateText } from "../translations/translationService";
import { getMoWithStoneDelivery, insertEntregaDePiedras } from "../services/ConnectDataBase";
import { SCREEN_IDS } from "../constants/Constants";
import { PARTS_MOVEMENTS_COLORS, CONSULTA_PIEZAS_COLORS } from "../style/colors.js";
        
export default function EntregaPiedrasScreen({ route }) {
  const name = useSelector((state) => state.user.name);
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const lang = useSelector((state) => state.lang.value);
  const inputRef = useRef(null);

  const fetchData = async (searchTerm) => {
    try {
      setIsLoading(true);
      setHasSearched(true);
  
      const data = await getMoWithStoneDelivery(
        SCREEN_IDS.GENERAL,
        "MoWithStoneDelivery",
        searchTerm
      );

        if (Array.isArray(data)) {
          setData(data);
        } else if (data && typeof data === 'object') {
          const dataArray = data.data || data.results || data.items || [];
          setData(Array.isArray(dataArray) ? dataArray : []);
        } else {
          console.warn("Datos no válidos recibidos:", data);
          setData([]);
        }
    } catch (error) {
      console.error("Error obteniendo datos:", error);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    if (!searchTerm.trim()) return;

    const codigos = searchTerm
      .split(',')
      .map(codigo => codigo.trim())
      .filter(codigo => codigo.length > 0)
      .map(codigo => codigo.replace(/'/g, '-')); 
    

    
    if (codigos.length > 0) {
      fetchData(codigos);
    }
  };

  const handleClear = () => {
    setSearchTerm("");
    setData([]);
    setHasSearched(false);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleKeyDown = (e) => {
    // Si se presiona Enter, agregar coma automáticamente
    if (e.key === 'Enter') {
      e.preventDefault();
      const currentValue = e.target.value;
      if (currentValue.trim() && !currentValue.endsWith(',')) {
        setSearchTerm(currentValue + ', ');
        // Mover el cursor al final
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
            inputRef.current.setSelectionRange(currentValue.length + 2, currentValue.length + 2);
          }
        }, 0);
      }
    }
  };


  const handleActionClick = async (item) => {

    const result = await insertEntregaDePiedras(SCREEN_IDS.GENERAL, "MarcadoEntregaPierdas", item.mo, name);
    if (result.status === "ok") {

    setData(prevData => 
        prevData.map(dataItem => 
        dataItem.mo === item.mo
          ? { ...dataItem, usuario_ok_piedras: name }
            : dataItem
        )
      );
    } else {
      console.log("Error al marcar como entregadas las piedras");
    }
  };

  const TableComponent = () => {
    return (
      <Paper
        sx={{
          borderRadius: 2,
          overflow: "hidden",
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          border: `1px solid ${PARTS_MOVEMENTS_COLORS.BORDER_LIGHT || "#e5e7eb"}`,
        }}>
        <TableContainer sx={{ maxHeight: "calc(78vh - 60px)" }}>
          <Table stickyHeader size="small" sx={{ width: "100%" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  align='center'
                  sx={{
                    fontWeight: 600,
                    backgroundColor: PARTS_MOVEMENTS_COLORS.BACKGROUND_TABLE_HEADER || "#F9FAFB",
                    borderBottom: `1px solid ${PARTS_MOVEMENTS_COLORS.BORDER_TABLE || "#e5e7eb"}`,
                    fontSize: "0.75rem",
                    color: "black",
                    py: 1,
                    px: 1.5,
                  }}>
                  {translateText("MO", lang)}
                </TableCell>
                <TableCell
                  align='center'
                  sx={{
                    fontWeight: 600,
                    backgroundColor: PARTS_MOVEMENTS_COLORS.BACKGROUND_TABLE_HEADER || "#F9FAFB",
                    borderBottom: `1px solid ${PARTS_MOVEMENTS_COLORS.BORDER_TABLE || "#e5e7eb"}`,
                    fontSize: "0.75rem",
                    color: "black",
                    py: 1,
                    px: 1.5,
                  }}>
                  {translateText("Código", lang)}
                </TableCell>
                <TableCell
                  align='center'
                  sx={{
                    fontWeight: 600,
                    backgroundColor: PARTS_MOVEMENTS_COLORS.BACKGROUND_TABLE_HEADER || "#F9FAFB",
                    borderBottom: `1px solid ${PARTS_MOVEMENTS_COLORS.BORDER_TABLE || "#e5e7eb"}`,
                    fontSize: "0.75rem",
                    color: "black",
                    py: 1,
                    px: 1.5,
                  }}>
                  {translateText("Quilates", lang)}
                </TableCell>
                <TableCell
                  align='center'
                  sx={{
                    fontWeight: 600,
                    backgroundColor: PARTS_MOVEMENTS_COLORS.BACKGROUND_TABLE_HEADER || "#F9FAFB",
                    borderBottom: `1px solid ${PARTS_MOVEMENTS_COLORS.BORDER_TABLE || "#e5e7eb"}`,
                    fontSize: "0.75rem",
                    color: "black",
                    py: 1,
                    px: 1.5,
                  }}>
                  {translateText("Peso", lang)}
                </TableCell>
                <TableCell
                  align='center'
                  sx={{
                    fontWeight: 600,
                    backgroundColor: PARTS_MOVEMENTS_COLORS.BACKGROUND_TABLE_HEADER || "#F9FAFB",
                    borderBottom: `1px solid ${PARTS_MOVEMENTS_COLORS.BORDER_TABLE || "#e5e7eb"}`,
                    fontSize: "0.75rem",
                    color: "black",
                    py: 1,
                    px: 1.5,
                  }}>
                  {translateText("Nº Piedras", lang)}
                </TableCell>
                <TableCell
                  align='center'
                  sx={{
                    fontWeight: 600,
                    backgroundColor: PARTS_MOVEMENTS_COLORS.BACKGROUND_TABLE_HEADER || "#F9FAFB",
                    borderBottom: `1px solid ${PARTS_MOVEMENTS_COLORS.BORDER_TABLE || "#e5e7eb"}`,
                    fontSize: "0.75rem",
                    color: "black",
                    py: 1,
                    px: 1.5,
                  }}>
                  {translateText("Entregar", lang)}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(data) && data.map((item, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": {
                      backgroundColor: PARTS_MOVEMENTS_COLORS.BACKGROUND_ROW_ALTERNATE || "#F9FAFB",
                    },
                    borderBottom: `1px solid ${PARTS_MOVEMENTS_COLORS.BORDER_LIGHT || "#e5e7eb"}`,
                  }}>
                  <TableCell
                    align='center'
                    sx={{
                      fontSize: "0.8rem",
                      py: 0.75,
                      px: 1.5,
                      color: PARTS_MOVEMENTS_COLORS.TEXT_PRIMARY || "#374151",
                    }}>
                    {item.mo}
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{
                      fontSize: "0.8rem",
                      py: 0.75,
                      px: 1.5,
                      color: PARTS_MOVEMENTS_COLORS.TEXT_PRIMARY || "#374151",
                    }}>
                    {item.codigo}
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{
                      fontSize: "0.8rem",
                      py: 0.75,
                      px: 1.5,
                      color: PARTS_MOVEMENTS_COLORS.TEXT_PRIMARY || "#374151",
                    }}>
                    {item.quilates.startsWith('.') ? '0' + item.quilates : item.quilates}
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{
                      fontSize: "0.8rem",
                      py: 0.75,
                      px: 1.5,
                      color: PARTS_MOVEMENTS_COLORS.TEXT_PRIMARY || "#374151",
                    }}>
                    {item.peso.startsWith('.') ? '0' + item.peso : item.peso}
                  </TableCell>
                  <TableCell
                    align='center'
                    sx={{
                      fontSize: "0.8rem",
                      py: 0.75,
                      px: 1.5,
                      color: PARTS_MOVEMENTS_COLORS.TEXT_PRIMARY || "#374151",
                    }}>
                    {parseFloat(item.numeropiedras).toFixed(2)}
                  </TableCell>
                  <TableCell align='center' sx={{ py: 0.75, px: 1.5 }}>
                    {item.usuario_ok_piedras ? (
                      <Typography
                        sx={{
                          color: PARTS_MOVEMENTS_COLORS.TEXT_MUTED || "#6B7280",
                          fontSize: "0.75rem",
                          fontWeight: 500,
                        }}>
                        {translateText("Entregado", lang)}
                      </Typography>
                    ) : (
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleActionClick(item)}
                        sx={{
                          backgroundColor: CONSULTA_PIEZAS_COLORS.BUTTON_EXCEL_PIEZAS,
                          color: "white",
                          fontSize: "0.75rem",
                          padding: "4px 12px",
                          height: "28px",
                          minWidth: "80px",
                          textTransform: "none",
                          borderRadius: 1,
                          boxShadow: "none",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            backgroundColor: "#45a049",
                            transform: "translateY(-1px)",
                            boxShadow: "0 2px 4px rgba(76, 175, 80, 0.2)",
                          },
                        }}>
                        {translateText("Entregar", lang)}
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  };

  return (
    <LinearGradient colors={backgroundColor()} style={styles.container}>
      <View style={styles.content}>
        {/* SearchBar con el mismo diseño que PartsMovements */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 1.5,
            padding: 1.5,
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow:
              "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)",
            border: `1px solid ${PARTS_MOVEMENTS_COLORS.BORDER_LIGHT || "#e5e7eb"}`,
            marginBottom: 1.5,
          }}>
          <Box sx={{ flex: 1, minWidth: "280px", position: "relative" }}>
            <InputBase
              inputRef={inputRef}
              value={searchTerm}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              sx={{
                width: "100%",
                backgroundColor: PARTS_MOVEMENTS_COLORS.BACKGROUND_CARD || "#F9FAFB",
                color: PARTS_MOVEMENTS_COLORS.TEXT_CARD || "#374151",
                fontSize: "0.85rem",
                fontWeight: 500,
                padding: "8px 12px 8px 40px",
                borderRadius: 2,
                border: `1.5px solid ${PARTS_MOVEMENTS_COLORS.BORDER_CARD || "#e5e7eb"}`,
                transition: "all 0.2s ease",
                fontFamily: "monospace",
                "&:hover": {
                  backgroundColor: PARTS_MOVEMENTS_COLORS.BACKGROUND_INPUT || "#F3F4F6",
                  borderColor: PARTS_MOVEMENTS_COLORS.BORDER_BRAND || "#174045",
                  boxShadow: "0 2px 4px rgba(70, 93, 100, 0.1)",
                },
                "&.Mui-focused": {
                  backgroundColor: "white",
                  borderColor: PARTS_MOVEMENTS_COLORS.BORDER_BRAND || "#174045",
                  boxShadow:
                    "0 0 0 2px rgba(70, 93, 100, 0.1), 0 2px 4px rgba(70, 93, 100, 0.1)",
                },
                "& input": {
                  padding: 0,
                },
                "& input::placeholder": {
                  color: PARTS_MOVEMENTS_COLORS.TEXT_MUTED || "#9CA3AF",
                  opacity: 1,
                },
              }}
              placeholder={translateText("Escanear códigos de piedras (separados por comas)...", lang)}
            />

            <Box
              sx={{
                position: "absolute",
                left: 16,
                top: "50%",
                transform: "translateY(-50%)",
                color: PARTS_MOVEMENTS_COLORS.TEXT_MUTED || "#9CA3AF",
                pointerEvents: "none",
              }}>
              <SearchIcon sx={{ fontSize: 18 }} />
            </Box>
          </Box>

          <Button
            onClick={handleSearch}
            variant='contained'
            size="small"
            startIcon={<SearchIcon />}
            disabled={!searchTerm.trim()}
            sx={{
              backgroundColor: PARTS_MOVEMENTS_COLORS.BACKGROUND_BUTTON_PRIMARY || "#174045",
              color: "white",
              borderRadius: 2,
              fontSize: "0.8rem",
              fontWeight: 600,
              padding: "6px 16px",
              textTransform: "none",
              boxShadow: "none",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: PARTS_MOVEMENTS_COLORS.BACKGROUND_BUTTON_SECONDARY || "#1e4d52",
                transform: "translateY(-1px)",
                boxShadow: "0 4px 12px rgba(70, 93, 100, 0.2)",
              },
              "&:disabled": {
                backgroundColor: PARTS_MOVEMENTS_COLORS.TEXT_MUTED || "#9CA3AF",
                color: "white",
              },
            }}>
            {translateText("Buscar", lang)}
          </Button>

          <Button
            onClick={handleClear}
            variant='outlined'
            size="small"
            startIcon={<ClearIcon />}
            sx={{
              borderColor: PARTS_MOVEMENTS_COLORS.BORDER_BRAND || "#174045",
              color: PARTS_MOVEMENTS_COLORS.BORDER_BRAND || "#174045",
              borderRadius: 2,
              fontSize: "0.8rem",
              fontWeight: 600,
              padding: "6px 16px",
              textTransform: "none",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: PARTS_MOVEMENTS_COLORS.BORDER_BRAND || "#174045",
                color: "white",
                transform: "translateY(-1px)",
                boxShadow: "0 2px 4px rgba(70, 93, 100, 0.2)",
              },
            }}>
            {translateText("Limpiar", lang)}
          </Button>
        </Box>

        {/* Información de códigos escaneados */}
        {searchTerm && (
          <Text style={styles.infoText}>
            {translateText("Códigos listos para buscar:", lang)} {searchTerm.split(',').filter(c => c.trim()).length}
          </Text>
        )}

        {/* Tabla */}
        <View style={{ flex: 1 }}>
          {isLoading ? (
            <Paper
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                border: `1px solid ${PARTS_MOVEMENTS_COLORS.BORDER_LIGHT || "#e5e7eb"}`,
              }}>
              <Box sx={{ p: 2 }}>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {[
                          translateText("MO", lang),
                          translateText("Código", lang),
                          translateText("Quilates", lang),
                          translateText("Peso", lang),
                          translateText("Nº Piedras", lang),
                          translateText("Entregar", lang),
                        ].map((header, i) => (
                          <TableCell key={i} sx={{ py: 1, px: 1.5 }}>
                            <Skeleton variant="text" width="100%" height={24} />
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {[...Array(5)].map((_, i) => (
                        <TableRow key={i}>
                          {[...Array(6)].map((_, j) => (
                            <TableCell key={j} sx={{ py: 0.75, px: 1.5 }}>
                              <Skeleton variant="text" width="100%" height={20} />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Paper>
          ) : hasSearched && (!Array.isArray(data) || data.length === 0) ? (
            <Paper
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                border: `1px solid ${PARTS_MOVEMENTS_COLORS.BORDER_LIGHT || "#e5e7eb"}`,
                textAlign: "center",
                py: 8,
              }}>
              <Typography variant='h6' sx={{ color: PARTS_MOVEMENTS_COLORS.TEXT_SECONDARY || "#6B7280" }}>
                {translateText("No se encontraron piedras para los códigos escaneados", lang)}
              </Typography>
            </Paper>
          ) : (
            <TableComponent />
          )}
        </View>
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    padding: 20,
  },
  loadingText: {
    textAlign: "center",
    fontSize: 16,
    color: "white",
    marginTop: 50,
  },
  noDataText: {
    textAlign: "center",
    fontSize: 16,
    color: "white",
    marginTop: 50,
    fontStyle: "italic",
  },
  infoText: {
    textAlign: "center",
    fontSize: 14,
    color: "white",
    marginBottom: 10,
    fontStyle: "italic",
  },
});
